<app-card class="flex-basis-100 mb-12">
  <div cardTitle i18n>Personnes à assurer</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div class="card__row">
        <span class="card__label" i18n>Nombre d'adultes</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.adultsCount,
            }"
            >{{ metadata.adultsCount }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.adultsCount &&
              originalMetadata?.adultsCount !== metadata.adultsCount
            "
            >{{ originalMetadata?.adultsCount }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.startDate || originalMetadata?.startDate"
      >
        <span class="card__label" i18n>Date de début souhaitée</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.startDate,
            }"
            >{{ metadata.startDate }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.startDate &&
              originalMetadata?.startDate !== metadata.startDate
            "
            >{{ originalMetadata.startDate }}</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div class="card__row">
        <span class="card__label" i18n>Nombre d'enfants</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.childrenCount,
            }"
            >{{ metadata.childrenCount }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.childrenCount &&
              originalMetadata?.childrenCount !== metadata.childrenCount
            "
            >{{ originalMetadata?.childrenCount }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>
